/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any */
import * as KatalMetrics from '@amzn/katal-metrics';
import KatalMetricsDriverArrayCollector from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverArrayCollector';
import KatalMetricsDriverConsoleLogJson from '@amzn/katal-metrics/lib/driver/KatalMetricsDriverConsoleLogJson';
import {
  type KatalMonitoringDriverOptions,
  KatalMonitoringDriver,
} from '@amzn/katal-monitoring-aws-driver';
import sentryFetch from '@amzn/sentry-fetch';
import config from 'src/config';

const monitoringUrl = `${config.monitoringBaseUrl}/v1/monitoring`;
const metricsConsoleErrorHandler = (err: Error) => {
  console.error(err);
};

const makeMetricsDriver = (): KatalMetrics.MetricsDriver => {
  if (process.env.NODE_ENV === 'test') {
    const metricsDriver = new KatalMetricsDriverArrayCollector();
    //  Attach to global window object so tests can see it
    (window as any).metricsDriver = metricsDriver;
    return metricsDriver;
  } else if (process.env.NODE_ENV !== 'production') {
    return new KatalMetricsDriverConsoleLogJson();
  } else {
    const monitoringDriverOptions: KatalMonitoringDriverOptions = {
      url: monitoringUrl,

      // Required since we use Katal's generated Midway interceptor
      backendApiOverride: async (body) => {
        try {
          await sentryFetch(monitoringUrl, {
            method: 'POST',
            credentials: 'include',
            body,
          });
        } catch (err) {
          console.error(err);
        }
      },
    };

    return new KatalMonitoringDriver(monitoringDriverOptions);
  }
};

const makePublisher = (): KatalMetrics.Publisher => {
  const metricsDriver = makeMetricsDriver();
  const initialMetricsContext = new KatalMetrics.Context.Builder()
    .withSite('MMELeela')
    .withServiceName('PVMMELeelaUI')
    .build();
  return new KatalMetrics.Publisher(
    metricsDriver,
    metricsConsoleErrorHandler,
    initialMetricsContext
  );
};

const initialMetricsPublisher = makePublisher();

export default initialMetricsPublisher;
